var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.09375C7.21875 0.8125 6.75 0.8125 6.46875 1.09375L0.375 7.15625C0.09375 7.46875 0.09375 7.9375 0.375 8.21875L1.09375 8.9375C1.375 9.21875 1.84375 9.21875 2.15625 8.9375L7 4.125L11.8125 8.9375C12.125 9.21875 12.5938 9.21875 12.875 8.9375L13.5938 8.21875C13.875 7.9375 13.875 7.46875 13.5938 7.15625L7.5 1.09375Z",
    fill: "#51A3AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.23528fd232c81ad3cdc6d59fda3c8888.svg";
export { ForwardRef as ReactComponent };